import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const AirPods = () => {
  return (
    <div>
      <Navbar />
      AirPods
      <Footer />

    </div>
  )
}

export default AirPods
